import React from "react";
import { Drawer, Box, Grid, TextField, MenuItem, Button } from "@mui/material";
import { HouseItem } from "./studentHouseApi";

interface Props {
  open: boolean;
  onClose: () => void;
  houses: HouseItem[];
  studentName: string;
  className: string;
  sectionName: string;
  onSubmit: (data: { houseId: string; assignedDate: string }) => void;
}

const HouseAssignForm: React.FC<Props> = ({ open, onClose, houses, studentName, className, sectionName, onSubmit }) => {
  const [houseId, setHouseId] = React.useState("");
  const [date, setDate] = React.useState(new Date().toISOString().split("T")[0]);

  const handleSave = () => {
    if (!houseId) return;
    onSubmit({ houseId, assignedDate: date });
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 360, p: 2 }}>
        <Box sx={{ fontWeight: 600, mb: 2 }}>Assign House</Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField label="Student" value={studentName} fullWidth disabled />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Class" value={className} fullWidth disabled />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Section" value={sectionName} fullWidth disabled />
          </Grid>
          <Grid item xs={12}>
            <TextField select fullWidth label="House" value={houseId} onChange={(e) => setHouseId(e.target.value)}>
              {houses.map((h) => (
                <MenuItem key={h.id} value={h.id}>
                  {h.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField label="Assigned Date" type="date" fullWidth value={date} onChange={(e) => setDate(e.target.value)} />
          </Grid>
          <Grid item xs={12} sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
            <Button onClick={onClose}>Cancel</Button>
            <Button variant="contained" onClick={handleSave}>
              Assign House
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Drawer>
  );
};

export default HouseAssignForm;
